<template>
  <div id="app">
    <navbar placement="static" type="default">
      <!-- Brand as slot -->
      <template slot="brand">
        <div class="navbar-header-bg-fix hidden-xs"></div>
        <a class="navbar-brand" href="#">
          <img src="./assets/logo.png" class="navbar-logo" alt="Friend or Fraud">
        </a>
      </template>

      <template slot="general">
        <form class="navbar-form navbar-right hidden-xs">
          <button type="button" class="btn_ btn-default_ e-btn -navbar" @click="openModal('requestCallModal')">Contact</button>
        </form>
        <ul class="nav navbar-nav navbar-right">
          <dropdown class="dropdown">
            <div slot="button-content">
              Services <!-- <span class="caret visible-xs-inline-block"></span> -->
            </div>
            <ul class="dropdown-menu" slot="dropdown-menu">
              <li>
                <a href="http://gateguard.xyz" target="_blank">
                  <div class="dd-h">GateGuard.xyz</div>
                  <div class="dd-desc">AI "Virtual Doorman" catch forbidden activity <nobr>+ add amenities</nobr></div>
                </a>
              </li>
              <li>
                <a href="http://propertypanel.xyz" target="_blank">
                  <div class="dd-h">PropertyPanel.xyz</div>
                  <div class="dd-desc">NYC’s most comprehensive real estate platform</div>
                </a>
              </li>
              <li>
                <a href="http://subletspy.com" target="_blank">
                  <div class="dd-h">SubletSpy.com</div>
                  <div class="dd-desc">Catch & evict illegal sublet"</div>
                </a>
              </li>
            </ul>
          </dropdown>
          <li><a href="#" v-scroll-to="'#press_anchor'">Press</a></li>
          <li><a href="#" v-scroll-to="'#about_anchor'">About</a></li>
          <li><a href="#" v-scroll-to="'#case_studies_anchor'">Case Studies</a></li>
        </ul>
      </template>
    </navbar>



    <div class="l-landing__top-banner">
      <div class="b-top-banner" :class="{ '-black': isBlackSlide }">
        <slick
          :options="topSliderOptions"
          ref="topSlider"
        >
          <div class="b-top-banner__item -chametzcatcher" v-if="isJoke">
            <div class="b-top-banner__desc">
              ChametzCatcher.xyz
            </div>
            <div class="b-top-banner__slogan">
              Catch & Evict Leavened Products
            </div>
            <div class="b-top-banner__img-helper"></div>
          </div>
          <div class="b-top-banner__item -general">
            <div class="b-top-banner__desc">
              We make Real Estate management proactive <nobr>with Artificial Intelligence</nobr>
            </div>
            <div class="b-top-banner__slogan">
              Trusted by over 100 top landlords and management companies
            </div>
            <div class="b-top-banner__img-helper"></div>
          </div>
          <div class="b-top-banner__item -propertypanel">
            <div class="b-top-banner__logo">
              <img src="./assets/banners/propertypanel-logo.png" alt="">
            </div>
            <div class="b-top-banner__desc">
              Find, Analyze, Manage, Service, Sell, Collaborate... <nobr>all from one panel.</nobr>
            </div>
            <div class="b-top-banner__slogan">
              NYC’s Most-Comprehensive Real Estate Platform
            </div>
            <div class="b-top-banner__img-helper"></div>
          </div>
          <div class="b-top-banner__item -gateguard">
            <div class="b-top-banner__logo">
              <img src="./assets/banners/gateguard-logo.png" alt="">
            </div>
            <div class="b-top-banner__desc">
              Turn any building into a luxury doorman building for $149/mo
            </div>
            <div class="b-top-banner__slogan -lg">
              Catch illegal activity <nobr>+ Add amenities</nobr>
            </div>
            <div class="b-top-banner__img-helper"></div>
          </div>
          <div class="b-top-banner__item -subletspy">
            <div class="b-top-banner__logo">
              <img src="./assets/banners/subletspy-logo.png" alt="">
            </div>
            <div class="b-top-banner__desc">
              Catch tenants on illegal sublet sites like Airbnb
            </div>
            <div class="b-top-banner__slogan -lg">
              Catch & Evict
            </div>
            <div class="b-top-banner__img-helper"></div>
          </div>
        </slick>
        <transition
          mode="out-in"
          enter-active-class="fadeInLeft"
          leave-active-class="fadeOutLeft"
          appear
        >
          <div class="b-top-banner__ribbon hidden-xs_ animated" v-if="currentSlideData.type=='chametzcatcher'">
            <div class="b-top-banner__ribbon-back"></div>
            <div class="b-top-banner__ribbon-title">
              Our systems caught & removed<br> 350 rent stabilized & thousands more FM<br> Airbnb hosts this year
            </div>
            <div class="b-top-banner__ribbon-slogan">
              Now our Artificial Intelligence will hunt your Chametz:<br> <nobr>Bread, Crackers, Pasta...</nobr>
            </div>
          </div>
        </transition>
        <transition
          mode="out-in"
          enter-active-class="fadeIn"
          leave-active-class="fadeOut"
          appear
        >
          <div class="b-top-banner__btns-box hidden-xs hidden-sm animated" v-if="currentSlideData.type!='general'">
            <a href="#" target="_blank" class="e-btn -simple-filled -lxx -up" @click="linkTrigger" v-bind:href="currentSlideData?currentSlideData.url:'#'">Learn more</a>
            <div class="clearfix"></div>
            <a href="#" target="_blank" class="e-btn -simple-filled -lxx -up" @click="linkTrigger" v-bind:href="currentSlideData?currentSlideData.url:'#'">Sign up now</a>
          </div>
        </transition>
        <transition
          mode="out-in"
          enter-active-class="fadeIn"
          leave-active-class="fadeOut"
          appear
        >
          <div class="b-top-banner__btns-helper animated" v-if="currentSlideData.type!='general'">
            <div class="b-top-banner__btns-box-sm visible-xs-inline-block visible-sm-inline-block">
              <a href="#" target="_blank" class="e-btn -simple-filled -ll -up" @click="linkTrigger" v-bind:href="currentSlideData?currentSlideData.url:'#'">Learn more</a>
              <a href="#" target="_blank" class="e-btn -simple-filled -ll -up" @click="linkTrigger" v-bind:href="currentSlideData?currentSlideData.url:'#'">Sign up now</a>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <div class="l-landing__services">
      <div class="b-services">
        <div class="container-fluid">
          <div class="row b-services__item-row">
            <div class="b-services__item-col col-lg-3 col-sm-6 col-xs-12">
              <a href="http://subletspy.com" target="_blank" class="b-services__item -subletspy">
                <img class="b-services__logo" src="./assets/products/subletspy-logo-p.png">
                <div class="b-services__desc">
                  Catch & Evict Illegal Subletters
                </div>
                <div class="b-services__img-helper"></div>
              </a>
            </div>
            <div class="b-services__item-col col-lg-3 col-sm-6 col-xs-12">
              <a href="http://gateguard.xyz" target="_blank" class="b-services__item -gateguard">
                <img class="b-services__logo" src="./assets/products/gateguard-logo-p.png">
                <div class="b-services__desc">
                  AI (robot!) Virtual Doorman
                </div>
                <div class="b-services__img-helper"></div>
              </a>
            </div>
            <div class="b-services__item-col col-lg-3 col-sm-6 col-xs-12">
              <a href="http://propertypanel.xyz" target="_blank" class="b-services__item -propertypanel">
                <img class="b-services__logo" src="./assets/products/propertypanel-logo-p.png">
                <div class="b-services__desc">
                  Find, Analyze, Manage, Service, Collaborate
                </div>
                <div class="b-services__img-helper"></div>
              </a>
            </div>
            <div class="b-services__item-col col-lg-3 col-sm-6 col-xs-12">
              <a href="http://friendorfraud.com" target="_blank" class="b-services__item -numberone">
                <img class="b-services__logo" src="./assets/products/numberone-logo-p.png">
                <div class="b-services__desc">
                  Power your vision
                </div>
                <div class="b-services__img-helper"></div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="l-landing__join">
      <mailchimp
        :action="'//FriendOrFraud.us9.list-manage.com/subscribe/post?u=eee388f544e40cc054f057c22&id=ebb8d85fa3'"
      ></mailchimp>
    </div>

    <div class="l-landing__helpful">
      <div class="b-helpful">
        <div class="container-fluid">
          <div class="b-helpful__h">
            How can we be helpful?
          </div>
          <div class="b-helpful__btns">
            <button type="button" class="e-btn -simple -lg -up" @click="openModal('requestCallModal')">Request a call</button>
            <button type="button" class="e-btn -simple -lg -up" @click="openModal('requestCallModal')">Schedule a demo</button>
          </div>
        </div>
      </div>
    </div>

    <div class="l-landing__news" id="press_anchor">
      <div class="b-news">
        <div class="b-news__h">In the news</div>
        <div class="b-news__friends">
          <div class="b-news__friends-item -pando"></div>
          <div class="b-news__friends-item -abc"></div>
          <div class="b-news__friends-item -daily-news"></div>
          <div class="b-news__friends-item -nbc"></div>
          <div class="b-news__friends-item -real-deal"></div>
          <div class="b-news__friends-item -pix-news"></div>
          <div class="b-news__friends-item -curbed"></div>
        </div>
        <div class="b-news__slider">
          <div class="container">
            <div class="b-news-slider">
              <slick
                :options="newsSliderOptions"
              >
                <a href="https://www.youtube.com/watch?v=dbemCw0heF8" target="_blank" class="b-news-slider__item">
                  <div class="b-news-slider__img -new1"></div>
                  <div class="b-news-slider__h">
                    ABC NEWS
                  </div>
                  <div class="b-news-slider__desc">
                    New Tool Helps Fight Illegal Sublets
                  </div>
                </a>
                <a href="https://therealdeal.com/2016/10/27/new-tool-allows-landlords-to-track-who-goes-in-and-out-of-rental-apartments/" target="_blank" class="b-news-slider__item">
                  <div class="b-news-slider__img -new3"></div>
                  <div class="b-news-slider__h">
                    The real deal
                  </div>
                  <div class="b-news-slider__desc">
                    New tool allows landlords to track who goes in and out of rental apartments
                  </div>
                </a>
                <a href="https://www.youtube.com/watch?v=I7eXutx1MJU" target="_blank" class="b-news-slider__item">
                  <div class="b-news-slider__img -new2"></div>
                  <div class="b-news-slider__h">
                    Pix11 News
                  </div>
                  <div class="b-news-slider__desc">
                    About Sublet Spy
                  </div>
                </a>
              </slick>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="l-landing__testimonials">
      <div class="b-testimonials">
        <div class="b-testimonials__h">
          Testimonials
        </div>
        <div class="container">
          <div class="row">
            <div class="col-xs-12">
              <div class="b-testimonials__slider">
                <slick
                  :options="testimonialsSliderOptions"
                >
                  <div class="b-testimonials__item">
                    <div class="b-testimonials__quote">
                      <div class="b-testimonials__quote-helper">
                        PropertyPanel.xyz keeps up more tuned-in to how our properties are performing and how they compare to nearby properties than any product or service on the market.<br>
                        We use it all day, every day.
                        <i></i>
                      </div>
                    </div>
                    <div class="b-testimonials__legend">
                      Michael Mintz<br>
                      CEO, MD&sup2; Property Management
                    </div>
                  </div>
                  <div class="b-testimonials__item">
                    <div class="b-testimonials__quote">
                      <div class="b-testimonials__quote-helper">
                        Your service is awesome!
                        <i></i>
                      </div>
                    </div>
                    <div class="b-testimonials__legend">
                      James<br>
                      Landlord, Los Angeles
                    </div>
                  </div>
                  <div class="b-testimonials__item">
                    <div class="b-testimonials__quote">
                      <div class="b-testimonials__quote-helper">
                        I wanted to call and thank you. You got rid of a nightmare for our condo by finding that Airbnb!
                        <i></i>
                      </div>
                    </div>
                    <div class="b-testimonials__legend">
                      Will<br>
                      Condo Board President, New York
                    </div>
                  </div>
                </slick>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="l-landing__halfbox" id="case_studies_anchor">
      <div class="b-halfbox">
        <div class="container-fluid">
          <div class="row">
            <div class="col-xs-12 col-md-6">
              <div class="b-halfbox__slider">
                <div class="b-halfbox__items">
                  <slick
                    :options="halfSliderOptions"
                  >
                    <div class="b-halfbox__item">
                      <div class="b-halfbox__h">Case studies</div>
                      <div class="b-halfbox__intro">
                        Ending Airbnb abuse in multifamily buildings
                      </div>
                      <div class="b-halfbox__text">
                        A top-10 landlord in NYC was inundated with complaints about illegal sublets throughout their rental portfolio. They signed up for SubletSpy.com and within 10 days had found over 60 offenders throughout. By the end of the month they had vacated 6 rent stabilized units and put an end to rampant abuse of illegal sublets.
                      </div>
                      <div class="text-center">
                        <a href="#" class="b-halfbox__link e-btn -link -lx">SubletSpy.com</a>
                      </div>
                    </div>
                    <div class="b-halfbox__item">
                      <div class="b-halfbox__h">Case studies</div>
                      <div class="b-halfbox__intro">
                        Evicting Airbnb hosts abusing stabilized housing
                      </div>
                      <div class="b-halfbox__text">
                        SubletSpy has evicted hundreds of Airbnb hosts abusing stabilized apartments, enabling landlords raise rents and add millions to their valuations.
                      </div>
                      <div class="text-center">
                        <a href="#" class="b-halfbox__link e-btn -link -lx">SubletSpy.com</a>
                      </div>
                    </div>
                    <div class="b-halfbox__item">
                      <div class="b-halfbox__h">Case studies</div>
                      <div class="b-halfbox__intro">
                        AI that catches duplicate & fake accounts
                      </div>
                      <div class="b-halfbox__text">
                        Our DupeDetector(TM) AI quickly found an illegal hotel operator with hiding behind over 40 accounts, enabling him to be shut down.
                      </div>
                      <div class="text-center">
                        <a href="#" class="b-halfbox__link e-btn -link -lx">SubletSpy.com</a>
                      </div>
                    </div>
                  </slick>
                </div>
              </div>
            </div>
            <div class="b-halfbox__collage-col col-xs-12 col-md-6">
              <div class="b-halfbox__collage">
                <div class="b-halfbox__collage-logo"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="l-landing__about" id="about_anchor">
      <div class="b-about">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-6">
              <div class="b-about__h">
                About us
              </div>
              <div class="b-about__slogan">
                Proactive, not reactive.
              </div>
              <div class="b-about__text">
                Friend or Fraud is a mission-driven, engineer-led firm headquartered in New York City,
                with team across the USA, Tel Aviv, and Eastern Europe.
                We create proprietary, world-best technology that helps over 100 of the world’s
                top landlords and management companies be proactive instead of reactive --
                alerting them to issues before they become problems.
              </div>
            </div>
            <div class="b-about__collage-col col-xs-12 col-sm-6">
              <div class="b-about__collage"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="l-landing__footer-panel">
      <div class="b-footer-panel">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-8 col-md-4">
              <div class="b-footer-panel__h">Solutions</div>
              <div class="b-footer-panel__items">
                <div class="b-footer-panel__item">
                  <a href="http://gateguard.xyz" target="_blank" class="b-footer-panel__item-link">GateGuard.xyz</a>
                  <div class="b-footer-panel__item-desc">
                    AI-powered virtual doorman catches forbidden activity + adds amenities
                  </div>
                </div>
                <div class="b-footer-panel__item">
                  <a href="http://propertypanel.xyz" target="_blank" class="b-footer-panel__item-link">PropertyPanel.xyz</a>
                  <div class="b-footer-panel__item-desc">
                    NYC’s most comprehensive real estate platform.
                    Find, Analyze, Manage, Service, Sell, Collaborate... <nobr>all from one panel.</nobr>
                  </div>
                </div>
                <div class="b-footer-panel__item">
                  <a href="http://subletspy.com" target="_blank" class="b-footer-panel__item-link">SubletSpy.com </a>
                  <div class="b-footer-panel__item-desc">
                    catch illlegal sublets on sites like Airbnb
                  </div>
                </div>
              </div>
              <div class="visible-xs-block"><hr></div>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-2">
              <div class="b-footer-panel__h">About</div>
              <div class="b-footer-panel__items">
                <!-- <div class="b-footer-panel__item">
                  <a href="#" class="b-footer-panel__item-link">Team</a>
                </div> -->
                <div class="b-footer-panel__item">
                  <a href="#" class="b-footer-panel__item-link" v-scroll-to="'#press_anchor'">Press</a>
                </div>
                <div class="b-footer-panel__item">
                  <a href="#" class="b-footer-panel__item-link" v-scroll-to="'#case_studies_anchor'">Case Studies</a>
                </div>
                <!-- <div class="b-footer-panel__item">
                  <a href="#" class="b-footer-panel__item-link">Job Opportunities</a>
                </div> -->
                <!-- <div class="b-footer-panel__item">
                  <a href="#" class="b-footer-panel__item-link">Events</a>
                </div> -->
              </div>
            </div>
            <div class="col-xs-12 col-md-6">
              <div class="b-footer-panel__btns-box">
                <div class="b-footer-panel__btns">
                  <button type="button" class="e-btn -simple -ll -up -min180" @click="openModal('requestCallModal')">Request a call</button> <br>
                  <button type="button" class="e-btn -simple -ll -up -min180" @click="openModal('requestCallModal')">Schedule a demo</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="l-landing__footer">
      <div class="container">
        <div class="b-footer">
          <span class="b-footer__copy">Copyright © 2017 Friend or Fraud Inc. <nobr>All rights reserved.</nobr></span>
        </div>
      </div>
    </div>

    <modal ref="requestCallModal" title="Request a call">
      <form class="b-form" @submit.prevent="validateBeforeSubmit">
        <div class="b-form__group form-group">
          <select class="b-form__control form-control input-lg" name="user_type"
            v-model="requestForm.user_type"
            v-validate="'required'"
            data-vv-name="requestForm.user_type"
            data-vv-validate-on="blur"
            :class="{ 'is-error': errors.has('requestForm.user_type') }"
          >
            <option value="" disabled>I am a</option>
            <option value="landlord">Landlord</option>
            <option value="management_company">Management Company</option>
            <option value="law_enforcement">Law Enforcement</option>
            <option value="Government">Government Official</option>
            <option value="Concerned_Neighbor">Concerned Neighbor</option>
            <option value="Host">Host</option>
            <option value="Sublet_Operator">Sublet Operator</option>
            <option value="Sublet_listing_website">Sublet Listing Website</option>
          </select>
          <span v-show="errors.has('requestForm.user_type')" class="b-mesbox -error">{{ errors.first('requestForm.user_type') }}</span>
        </div>
        <div class="b-form__group form-group">
          <input type="text" class="b-form__control form-control input-lg" name="name_f" placeholder="First name"
            v-model="requestForm.name_f"
            v-validate="'required'"
            data-vv-name="requestForm.name_f"
            data-vv-validate-on="blur"
            :class="{ 'is-error': errors.has('requestForm.name_f') }"
          >
          <span v-show="errors.has('requestForm.name_f')" class="b-mesbox -error">{{ errors.first('requestForm.name_f') }}</span>
        </div>
        <div class="b-form__group form-group">
          <input type="text" class="b-form__control form-control input-lg" name="name_l" placeholder="Last name"
            v-model="requestForm.name_l"
            v-validate="'required'"
            data-vv-name="requestForm.name_l"
            data-vv-validate-on="blur"
            :class="{ 'is-error': errors.has('requestForm.name_l') }"
          >
          <span v-show="errors.has('requestForm.name_l')" class="b-mesbox -error">{{ errors.first('requestForm.name_l') }}</span>
        </div>
        <div class="b-form__group form-group">
          <input type="text" class="b-form__control form-control input-lg" name="email" placeholder="my email is"
            v-model="requestForm.email"
            v-validate="'required|email'"
            data-vv-name="requestForm.email"
            data-vv-validate-on="blur"
            :class="{ 'is-error': errors.has('requestForm.email') }"
          >
          <span v-show="errors.has('requestForm.email')" class="b-mesbox -error">{{ errors.first('requestForm.email') }}</span>
        </div>
        <div class="b-form__group form-group">
          <input type="text" class="b-form__control form-control input-lg" name="phone" placeholder="my phone is"
            v-model="requestForm.phone"
            v-validate="'required'"
            data-vv-name="requestForm.phone"
            data-vv-validate-on="blur"
            :class="{ 'is-error': errors.has('requestForm.phone') }"
          >
          <span v-show="errors.has('requestForm.phone')" class="b-mesbox -error">{{ errors.first('requestForm.phone') }}</span>
        </div>
        <div class="b-form__group form-group">
          <select class="b-form__control form-control input-lg" name="subject"
            v-model="requestForm.subject"
            v-validate="'required'"
            data-vv-name="requestForm.subject"
            data-vv-validate-on="blur"
            :class="{ 'is-error': errors.has('requestForm.subject') }"
          >
            <option value="" disabled>Subject</option>
            <option value="subscribing">Subscribing</option>
            <option value="legal">Legal Question</option>
            <option value="law">Law enforcement</option>
            <option value="press">Press</option>
          </select>
          <span v-show="errors.has('requestForm.subject')" class="b-mesbox -error">{{ errors.first('requestForm.subject') }}</span>
        </div>
        <div class="b-form__group form-group">
          <textarea class="b-form__control form-control input-lg" rows="3" name="message" placeholder="Message"></textarea>
        </div>
        <button type="submit" class="e-btn -send -lx -up -block" :disabled="requestFormLoading">Submit</button>
      </form>
    </modal>

    <modal ref="jokeModal" title="April Fools!">
      <p>But we can help you catch & evict illegal subletters<br/>with SubletSpy & GateGuard.xyz.</p>
    </modal>

  </div>
</template>

<script>
import $ from 'jquery'
import dropdown from 'components/ui/Dropdown'
import navbar from 'components/ui/Navbar'
import slick from 'components/ui/Slick'
import modal from 'components/ui/Modal'
import mailchimp from 'components/ui/Mailchimp'
import { find as _find } from 'lodash'

export default {
  name: 'app',
  components: {
    dropdown,
    navbar,
    slick,
    modal,
    mailchimp
  },
  data () {
    return {
      currentSlide: 0,
      isBlackSlide: false,
      isJoke: false,
      topSliderData: [
        {
          type: 'general',
          url: 'http://friendorfraud.com'
        },
        {
          type: 'propertypanel',
          url: 'http://propertypanel.xyz'
        },
        {
          type: 'gateguard',
          url: 'http://gateguard.xyz'
        },
        {
          type: 'subletspy',
          url: 'http://subletspy.com'
        }
      ],
      topSliderOptions: {
        dots: false,
        infinite: true,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'cubic-bezier(.65, 0, .15, 1)'
      },
      testimonialsSliderOptions: {
        dots: true,
        arrows: false,
        infinite: true,
        fade: true,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 6000
      },
      halfSliderOptions: {
        dots: true,
        arrows: false,
        infinite: true,
        fade: true,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 6000
      },
      newsSliderOptions: {
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 650,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      },
      requestForm: {
        'user_type': '',
        'name_f': '',
        'name_l': '',
        'email': '',
        'phone': '',
        'subject': '',
        'message': ''
      },
      requestFormLoading: false,
      requestFormServerError: null
    }
  },
  computed: {
    currentSlideData () {
      return this.topSliderData[ this.currentSlide ] || {}
    }
  },
  created () {
    this.isJoke = window.location.search.indexOf('chametz') >= 0

    this.isJoke && this.topSliderData.unshift({
      type: 'chametzcatcher',
      url: 'http://chametzcatcher.xyz'
    })
  },
  mounted () {
    this.$refs['topSlider'].$on('afterChange', (event, slick, currentSlide) => {
      this.currentSlide = currentSlide||0
    })
    this.$refs['topSlider'].$on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      let goalSlideIndex = this.isJoke?4:3
      if (nextSlide === goalSlideIndex) {
        this.isBlackSlide = true
      }
      if (currentSlide === goalSlideIndex) {
        this.isBlackSlide = false
      }
    })
  },
  methods: {
    openModal(ref) {
      this.$refs[ref].open()
    },
    closeModal(ref) {
      this.$refs[ref].close()
    },
    linkTrigger(e) {
      if (this.currentSlideData.type=='chametzcatcher') {
        e.preventDefault()
        e.stopPropagation()
        this.openModal('jokeModal')
        return
      }
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(success => {
        success && this.submit()
      });
    },
    submit () {
      let self = this,
          data = this.requestForm;

      this.requestFormServerError = null
      this.requestFormLoading = true

      $.post('/formUrl', data)
        .done(function() {
          self.requestFormLoading = false
          self.articles = resp
          self.closeModal('requestCallModal')
        })
        .fail(function() {
          self.requestFormLoading = false
          self.requestFormServerError = 'Server error occured.'
        });
    }
  }
}
</script>

<style lang="scss">
@import '~animate.css';
.animated {
  animation-duration: .377s;
}
</style>



// WEBPACK FOOTER //
// App.vue?27f51876